<template>
  <q-expansion-item
    v-if="children.length"
    expand-separator
    :icon="icon"
    :label="text"
  >
    <NavigationItem
      v-for="(route, index) in children"
      :key="index"
      v-bind="route"
      class="q-ml-lg"
    />
  </q-expansion-item>

  <NavigationItem
    v-else
    :text="text"
    :path="path"
    :icon="icon"
    :light="light"
    :callBack="callBack"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import NavigationItem from './NavigationItem.vue'

export default defineComponent({
  name: 'NavigationItemWrapper',
  components: {
    NavigationItem
  },
  props: {
    children: {
      type: Array,
      default: () => []
    },
    path: {
      type: String
    },
    text: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    light: {
      type: Boolean,
      default: false
    },
    value: {
      type: String
    },
    callBack: {
      type: Function,
      default: () => {
        return null
      }
    }
  }
})
</script>
